import API_KEYS from './api-keys';

export const END_OF_2025_GUIDE = new Date(API_KEYS.end_of_2025_guide);